<div class="card z-depth-1 sidebar" data-testid="checkout-items">
  <div class="backdrop" *ngIf="isWaiting">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div class="card-body">
    <h5 class="d-flex justify-content-between align-items-center mb-3">
      <strong><span class="text-muted">{{ model?.itemCount }} Cart items</span></strong>
      <a class="grey-text small" href="/cart"><i class="fas fa-edit"></i> Edit</a>
    </h5>
    <hr />
    <checkout-cart-bundle-items *ngFor="let p of this.model.BundleSets" [BundleSet]="p"></checkout-cart-bundle-items>
    <div *ngFor="let p of this.model.UnBundledItems ?? []" attr.data-testid="checkout-item-{{p.Webcode}}" class="w-100 checkout-item-row">
      <div class="row">
          <div class="col-3">
              <img src="{{ getImageURL(p.ImageDataburst) }}" alt="" width="60" />
          </div>
          <div class="col-6">
              <div>
                  <small data-testid="checkout-item-description">{{ p.Description }}</small><br />
                  <small>Webcode: <span data-testid="checkout-item-webcode">{{ p.Webcode }}</span></small>
              </div>
          </div>
          <div class="col-3 pr-0">
              <div>
                  <small data-testid="checkout-item-unit-price" style="display: none">{{ p.UnitPrice | currency }}</small>
                  <small data-testid="checkout-item-total-price">{{ p.LineTotal | currency }}</small><br />
                  <small class="text-muted">Qty <span data-testid="checkout-item-quantity">{{ p.Quantity }}</span></small>
              </div>
          </div>
          <div class="col-12">
              <div>
                  <small
                      *ngIf="p.IsDigitalItem"
                      class="badge green mb-1"
                      triggers="hover"
                      placement="right"
                      container="body"
                      mdbPopoverHeader="Digital Item"
                      style="color: white; width: fit-content; display: block;"
                      mdbPopover="This item is digital. It will be delivered via email."
                  >
                      Digital Item <i class="fas fa-question-circle"></i>
                  </small>

                  <small
                      *ngIf="showDropshippingBadge && dropshippedItems.includes(p.Webcode)"
                      style="color: white; width: fit-content; display: block;"
                      class="badge orange hand mb-1"
                      triggers="hover"
                      placement="top"
                      container="body"
                      [mdbPopover]="dropshippedItemTemplate"
                      mdbPopoverHeader="Additional Drop Ship Quote Required"
                  >
                      Additional Drop Ship Quote Required <i class="fas fa-info-circle"></i>
                  </small>

                  <small *ngIf="p.FinalSale"
                         class="badge red hand mb-1"
                         triggers="hover"
                         placement="top"
                         container="body"
                         style="color: white; width: fit-content; display: block;"
                         mdbPopoverHeader="Special Order:"
                         mdbPopover="Special Order items are ordered from the manufacturer and may take weeks to arrive. It requires a full, non-refundable payment."
                  >
                      Special order <i class="fas fa-info-circle"></i>
                  </small>
                  
                  <small 
                      class="text-muted mb-1"
                      style="width: fit-content; display: block;"
                      *ngIf="!p.FinalSale"
                  > 
                      {{ p.StockingStatus }}
                  </small>
                  
                  <small 
                      class="text-muted mb-1"
                      style="width: fit-content; display: block;"
                      *ngIf="p.StockingStatus === 'In Stock'"
                  >
                      Ready to Ship
                  </small>
              </div>
          </div>
      </div>
    </div>

    <hr />
    <h6 class="d-flex justify-content-between align-items-center">
      <strong><span class="">Total</span></strong>
      <span class=""><strong>{{ this.model?.CartSummary?.Subtotal | currency }}</strong></span>
    </h6>
    <ng-container *ngIf="this.model.OrderLevelPromotions?.length > 0">
      <hr />
      <h6>Promotion</h6>
      <table mdbtable responsive="false" style="table-layout: fixed; width: 100%;">
        <tbody>
          <tr 
              *ngFor="let p of this.model.OrderLevelPromotions"
              [attr.data-testid]="p.Attributes.TriggerCoupon ? 'cart-coupon-' + p.Attributes.TriggerCoupon : 'cart-order-discount-' + p.Description"
          >
            <td style="width: auto; vertical-align: top;">
              <small [class]="p.Attributes.TriggerCoupon ? 'cart-order-coupon-name' : 'cart-order-discount-name'">
                  {{ p.Description }}
              </small>
              <br />
              <small 
                class="text-muted" 
                *ngIf="p.Attributes.TriggerCoupon"
              >
                Coupon: <span class="cart-order-coupon-code">{{ p.Attributes.TriggerCoupon }}</span>
              </small>
            </td>
            <td style="text-align: right; width: 100px;">
              <div 
                  *ngIf="p.Webcode === TalonOneWebCode.T1ODISCOUNT"
              >
                <strong class="cart-order-discount-amount">{{ p.UnitPrice | currency }}</strong>
              </div>
              <br />
              <div class="small hand btnItem" (click)="removeItem()" *ngIf="p.Attributes.TriggerCoupon">
                <mdb-icon far icon="trash-alt"></mdb-icon> Remove
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </div>
</div>

<!-- Cart -->

<!-- Help section-->
<div class="p-3" style="border-radius: 6px; color: #424243; background-color: #f2f4f5">
  <div class="card-body" style="padding-left: 20px">
    <div class="content text-muted" style="padding-top: 10px; padding-bottom: 10px">
      <h5><strong>Our team is here to help you.</strong></h5>
      <hr />
      <h6>
        <i class="fa fa-phone-square" aria-hidden="true"></i><strong class="leftspace">Call us: 1.888.365.1777</strong>
      </h6>
      <p class="text-muted">
        <a href="/about/shipping">Shipping</a> | <a href="/about/returns">Returns</a> |
        <a href="/about/privacy/">Privacy</a>
      </p>
      <hr />
      <h6><i class="fa fa-lock" aria-hidden="true"></i><strong class="leftspace">Secure at Vistek</strong></h6>
      <small class="text-muted">
        All personal information you provide will be confidential and Transactions on Vistek.ca are secure</small
      >
    </div>
  </div>
</div>

<!--Grid column-->

<ng-template #dropshippedItemTemplate>
    <p>This item is dropshipped and is not calculated in your instant shipping quote.</p>
    <p>You will be contacted after your order is placed with a shipping quote for the dropshipped item(s).</p>
</ng-template>